export function roundNumberToOneDecimal(number) {
	return Math.round(number * 10) / 10;
}
